<template>
    <div id="garantia">
        <div class="fundo-branco garantia">
        
            <div class="item">
                <div class="imagem">
                    <img width="90px" src="@/assets/garantia/garantia-total.png" alt="">
                </div>
                <div class="descricao">
                    <p>Garantia de entrega</p>
                </div>
            </div>
             
            <div class="item">
                <div class="imagem">
                    <img width="90px" src="@/assets/garantia/frete-gratis.png" alt="">
                </div>
                <div class="descricao">
                    <p>Serviço de Qualidade</p>
                </div>
            </div>
           
            <div class="item">
                <div class="imagem">
                    <img width="90px" src="@/assets/garantia/parcelamento.png" alt="">
                </div>
                <div class="descricao">
                    <p>Parcelamento no cartão</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

#garantia {
    width: 100%;
    background: #e17e4b;
}

.garantia {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    padding-left: 150px;
    padding-right: 150px;
    padding-top: 50px;
    padding-bottom: 50px;
}

.fundo-branco {
    background: #e17e4b;
    width: 100%;
    height: 100%;
}


.item .descricao p {
    color: white;
    text-transform: uppercase;
    font-weight: 500;
    text-align: center;
}

.item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 220px;
    margin: 20px 30px 20px 30px;
}

</style>